module.exports = __webpack_public_path__ + "img/20190918172355360截图20190918161548536.70c13e0e.jpg";